var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalAccountRed48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_9)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0ZM24 1.11628C11.3617 1.11628 1.11628 11.3617 1.11628 24C1.11628 36.6383 11.3617 46.8837 24 46.8837C36.6383 46.8837 46.8837 36.6383 46.8837 24C46.8837 11.3617 36.6383 1.11628 24 1.11628Z",
    fill: "#A00000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27.907C25.8322 27.907 27.6466 28.311 29.3394 29.0963C31.0323 29.8817 32.5709 31.0332 33.8666 32.4844C35.1623 33.9355 36.1905 35.6585 36.8917 37.5545C37.5929 39.4505 37.9535 41.4827 37.9535 43.5349H36.8372C36.8372 41.6293 36.5055 39.7423 35.8605 37.9818C35.2153 36.2212 34.2694 34.6211 33.0774 33.2736C31.8854 31.9261 30.4695 30.8568 28.9121 30.1275C27.3547 29.3984 25.6856 29.0233 24 29.0233C22.3144 29.0233 20.6453 29.3984 19.0879 30.1275C17.5305 30.8568 16.1146 31.9261 14.9226 33.2736C13.7306 34.6211 12.7847 36.2212 12.1395 37.9818C11.4945 39.7423 11.1628 41.6293 11.1628 43.5349H10.0465C10.0465 41.4827 10.4071 39.4505 11.1083 37.5545C11.8095 35.6585 12.8377 33.9355 14.1334 32.4844C15.4291 31.0332 16.9677 29.8817 18.6606 29.0963C20.3534 28.311 22.1678 27.907 24 27.907Z",
    fill: "#A00000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 16.186C27.3908 16.186 30.1395 18.9348 30.1395 22.3256C30.1395 25.7164 27.3908 28.4651 24 28.4651C20.6092 28.4651 17.8605 25.7164 17.8605 22.3256C17.8605 18.9348 20.6092 16.186 24 16.186ZM24 17.1072C21.1178 17.1072 18.7816 19.4434 18.7816 22.3256C18.7816 25.2077 21.1178 27.544 24 27.544C26.8822 27.544 29.2184 25.2077 29.2184 22.3256C29.2184 19.4434 26.8822 17.1072 24 17.1072Z",
    fill: "#A00000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalAccountRed48);
export default __webpack_public_path__ + "static/media/personal_account_red48.95cfec165afd272fb54a15cea2e07d5f.svg";
export { ForwardRef as ReactComponent };